/**
 * ModalHeader — title row + close button used at the top of every
 * tools-panel modal.
 */
import type { ReactNode } from 'react'

interface ModalHeaderProps {
  title: ReactNode
  onClose: () => void
}

export default function ModalHeader({ title, onClose }: ModalHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
      }}
    >
      <div style={{ fontSize: 18, fontWeight: 700 }}>{title}</div>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          color: 'var(--text-muted)',
          cursor: 'pointer',
          fontSize: 20,
        }}
      >
        ✕
      </button>
    </div>
  )
}
